import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  UnitSearchModelsRequest,
  UnitSearchModelsResponse,
} from '../models/unit-search.model';
import {
  UnitSearchResponse,
  UnitSearchStockRequest,
} from '../models/unit-search-stock.model';
import {
  ProfileDetailBgtRequest,
  ProfileDetailBgtResponse,
} from '../models/profile-details-bgt.model';
import { CosyUrlResponse } from '../models/cosy.model';
import {
  UnitUpdateRequest,
  UnitUpdateResponse,
  Z11UpdateUnitHeaderRequest,
  Z11UpdateUnitHeaderResponse,
} from '../models/unit-update-model';
import { UnitUpdateHistoryResponse } from '../models/unit-update-history.model';
import { ModelOption } from '../models/stock-item.model';
import { UnitSearchReserveRequest } from '../models/unit-search-reserve.models';
import {
  UnitSearchHoldRequest,
  UnitSearchHoldResponse,
} from '../models/unit-search-hold.model';
import {
  NatisUserRequest,
  Z11GetUserDetailResponse,
} from '../models/user-details.model';
import { Z11CallIvsrRequest, Z11CallIvsrResponse } from '../models/ivst.model';
import { ZSnEncodeResponse } from '../models/dealer-summary.model';

@Injectable({
  providedIn: 'root',
})
export class CrossBorderService {
  constructor(private readonly http: HttpClient) {}

  getProfileDetails(
    requestPayload: ProfileDetailBgtRequest
  ): Observable<ProfileDetailBgtResponse> {
    const url = `/cross-border/profile-detail-bgt`;
    console.log(requestPayload);
    return this.http.post<ProfileDetailBgtResponse>(url, requestPayload);
  }

  getUserDetails(
    requestPayload: NatisUserRequest
  ): Observable<Z11GetUserDetailResponse> {
    const url = `/cross-border/user-details`;
    console.log(requestPayload);
    return this.http.post<Z11GetUserDetailResponse>(url, requestPayload);
  }

  // getAvailableStock(requestPayload: RequestPayload): Observable<StockResponse> {
  //   const url = `/stock/available-stock`;
  //   console.log(requestPayload);
  //   return this.http.post<StockResponse>(url, requestPayload);
  // }

  getUnitSearchModels(
    requestPayload: UnitSearchModelsRequest
  ): Observable<UnitSearchModelsResponse> {
    const url = `/cross-border/unit-search-models`;
    console.log(requestPayload);
    return this.http.post<UnitSearchModelsResponse>(url, requestPayload);
  }
  getEncodedUserId(request: NatisUserRequest): Observable<ZSnEncodeResponse> {
    const url = `/cross-border/encode-username`;
    console.log(request);
    return this.http.post<ZSnEncodeResponse>(url, request);
  }

  getUnitSearchStock(
    requestPayload: UnitSearchStockRequest
  ): Observable<UnitSearchResponse> {
    const url = `/cross-border/search-unit-stock`;
    console.log(requestPayload);
    return this.http.post<UnitSearchResponse>(url, requestPayload);
  }

  getCosyUrl(requestPayload: {
    VIN: string | number | ModelOption[];
  }): Observable<CosyUrlResponse> {
    const url = `/cross-border/cosy-url`;
    return this.http.post<CosyUrlResponse>(url, requestPayload);
  }

  unitUpdate(
    requestPayload: UnitUpdateRequest
  ): Observable<UnitUpdateResponse> {
    const url = `/cross-border/unit-update`;
    console.log(requestPayload);
    return this.http.post<UnitUpdateResponse>(url, requestPayload);
  }

  unitUpdateHeader(
    requestPayload: Z11UpdateUnitHeaderRequest
  ): Observable<Z11UpdateUnitHeaderResponse> {
    const url = `/cross-border/unit-update-header`;
    console.log(requestPayload);
    return this.http.post<Z11UpdateUnitHeaderResponse>(url, requestPayload);
  }

  callIvsr(
    requestPayload: Z11CallIvsrRequest
  ): Observable<Z11CallIvsrResponse> {
    const url = `/cross-border/call-ivsr-update-header`;
    console.log(requestPayload);
    return this.http.post<Z11CallIvsrResponse>(url, requestPayload);
  }
  unitUpdateHistory(
    requestPayload: UnitUpdateRequest
  ): Observable<UnitUpdateHistoryResponse> {
    const url = `/cross-border/unit-update-history`;
    console.log(requestPayload);
    return this.http.post<UnitUpdateHistoryResponse>(url, requestPayload);
  }
  unitSearchReserve(
    requestPayload: UnitSearchReserveRequest
  ): Observable<UnitSearchModelsResponse> {
    const url = `/cross-border/unit-search-reserve`;
    console.log(requestPayload);
    return this.http.post<UnitSearchModelsResponse>(url, requestPayload);
  }
  getUnitSearchHold(
    request: UnitSearchHoldRequest
  ): Observable<UnitSearchHoldResponse> {
    const url = `/cross-border/hold`;
    console.log(request);
    return this.http.post<UnitSearchHoldResponse>(url, request);
  }

  getUnitSearchAvailableAllocation(
    request: UnitSearchHoldRequest
  ): Observable<UnitSearchHoldResponse> {
    const url = `/cross-border/unit-search-available-aloc`;
    console.log(request);
    return this.http.post<UnitSearchHoldResponse>(url, request);
  }

  downloadStockSheet(requestPayload: UnitSearchStockRequest): Observable<Blob> {
    const url = '/cross-border/stocksheet';
    return this.http.post(url, requestPayload, {
      responseType: 'blob',
    });
  }
}
